<span class="fa fa-regular fa-lg fa-triangle-exclamation m-2"></span>
<h2 class="message" translate="state_error.loading_data"></h2>
<button type="button" class="btn btn-outline-dark" (click)="onRetry()">
  {{ 'common.actions.retry' | translate }}
  <span class="fa fa-regular fa-sm fa-rotate"></span>
</button>
